module.exports = __webpack_public_path__ + "img/icons BFr_35.1901a677.svg";